import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchTransports = (dealer, agency) => apiActionCreator({
  'endpoint': `/transports/dealer/${dealer}/agencies/${agency}/carriers`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_TRANSPORTS_LIST,
    ActionTypes.FETCHED_TRANSPORTS_LIST,
    [
      ActionTypes.FETCHED_TRANSPORTS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
